import { DoubleQuarterStaircase } from '../SceneModule';
import {TemporaryStaircase} from './TemporaryStaircase';

export class TemporaryDoubleQuarterStaircase extends TemporaryStaircase
{
    public stepWidth: number;
    public hasBearing: boolean;
    public modifiedWidth: number;

    constructor(techElement: DoubleQuarterStaircase) {
        // Call mother class
        super(techElement);
        // And save step width class member in addition to all standard members of staircases
        this.stepWidth = techElement.stepWidth;
        // And save bearing
        this.hasBearing = techElement.hasBearing;
        // And save last length
        this.modifiedWidth = techElement.modifiedWidth;
    }
}
